import api from "./client";
import type { DataCompleteness } from "../types";

/**
 * Veri tamlık skoru ("AI-ready") — seçili proje kapsamında son period_days
 * gündeki eksikleri ağırlıklı cezayla 100'den düşer (izin: dashboard.view +
 * proje üyeliği).
 */
export async function fetchDataCompleteness(projectId: number): Promise<DataCompleteness> {
  const response = await api.get("/api/v1/data-completeness", {
    params: { project_id: projectId },
  });
  return response.data.data;
}
